import { ModalContent } from "./ModalContent"
import { RiShieldKeyholeFill } from "react-icons/ri"
import { HiOutlineExternalLink } from "react-icons/hi"

export const BannedModalContent = (props) => {
    const banReason = props.banReason || ''

    return (
        <ModalContent
        click={props.click}
        hideTitle={true}
        hide={false}
        title={``}
        className={`modal-content-login modal-content-banned`}
        content={
            <div style={{
                maxWidth: '420px',
                width: '100%',
                margin: '0 auto',
                fontFamily: '"Inter Tight", "Poppins", sans-serif',
            }}>
                {/* Card */}
                <div style={{
                    background: 'var(--bg-color-3)',
                    borderRadius: '16px',
                    border: '1px solid rgba(255,255,255,0.06)',
                    overflow: 'hidden',
                }}>
                    {/* Red accent bar */}
                    <div style={{
                        height: '3px',
                        background: 'linear-gradient(90deg, #dc2626, #ef4444, #dc2626)',
                    }} />

                    {/* Content */}
                    <div style={{ padding: '28px 24px 24px' }}>
                        {/* Icon + Title */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '12px',
                            marginBottom: '20px',
                        }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '14px',
                                background: 'rgba(220, 38, 38, 0.12)',
                                border: '1px solid rgba(220, 38, 38, 0.2)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <RiShieldKeyholeFill style={{ fontSize: '22px', color: '#ef4444' }} />
                            </div>
                            <div style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#ef4444',
                                letterSpacing: '-0.3px',
                            }}>
                                Account Suspended
                            </div>
                        </div>

                        {/* Message */}
                        <p style={{
                            fontSize: '13px',
                            lineHeight: '1.6',
                            color: 'var(--text-gray-5)',
                            textAlign: 'center',
                            margin: '0 0 18px',
                            fontFamily: '"Poppins", sans-serif',
                        }}>
                            Your account has been suspended for violating our Terms & Conditions.
                        </p>

                        {/* Reason box */}
                        {banReason !== '' && (
                            <div style={{
                                background: 'rgba(220, 38, 38, 0.08)',
                                border: '1px solid rgba(220, 38, 38, 0.15)',
                                borderRadius: '10px',
                                padding: '12px 16px',
                                marginBottom: '18px',
                            }}>
                                <div style={{
                                    fontSize: '10px',
                                    fontWeight: '600',
                                    color: 'var(--text-gray-4)',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.8px',
                                    marginBottom: '4px',
                                }}>
                                    Reason
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: '#fca5a5',
                                }}>
                                    {banReason}
                                </div>
                            </div>
                        )}

                        {/* Divider */}
                        <div style={{
                            height: '1px',
                            background: 'rgba(255,255,255,0.06)',
                            margin: '0 0 14px',
                        }} />

                        {/* Appeal note */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            fontSize: '12px',
                            color: 'var(--text-gray-4)',
                            fontFamily: '"Poppins", sans-serif',
                            flexWrap: 'wrap',
                        }}>
                            Think this is wrong? Appeal via the
                            <span style={{
                                color: 'var(--text-brand)',
                                fontWeight: '500',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '3px',
                            }}>
                                Support tab <HiOutlineExternalLink style={{ fontSize: '11px' }} />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        }/>
    )
}
